var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-ponuka overflow-hidden"
  }, [_c('ul', {
    staticClass: "our-menu nt5 cf nl4 nl5-l nr4 nr5-l"
  }, [_vm._l(([_vm.menuCategoriesFood, _vm.menuCategoriesDrinks]), function(categoriesGroup, categoryGroupIx) {
    return [_c('div', {
      staticClass: "MenuCategoriesGroup"
    }, _vm._l((categoriesGroup), function(category, i) {
      return _c('div', {
        staticClass: "dib w-100 ph4 ph5-l mt5"
      }, [_c('smp-menu-category', {
        attrs: {
          "title": _vm.isEnglish ? category.nameEn : category.name,
          "image": category.hasImg ? _vm.isEnglish ? ("/images/menu/en/" + (category['id']) + ".png") : ("/images/menu/" + (category['id']) + ".png") : null
        }
      }, _vm._l((_vm.menuItemsInCategory(category['id'])), function(menuItem, i) {
        return _c('smp-menu-item', {
          key: _vm.isEnglish ? menuItem.nameEn : menuItem.name,
          staticClass: "mt4 white",
          attrs: {
            "name": _vm.isEnglish ? menuItem.nameEn : menuItem.name,
            "price": menuItem.price,
            "allergens": menuItem.allergens,
            "isLast": i % 2 === 1,
            "text": _vm.isEnglish ? menuItem.popisEn : menuItem.popis,
            "weight": menuItem.porcia
          }
        })
      }))], 1)
    })), _vm._v(" "), _c('div', {
      staticClass: "dn db-ns"
    }, [(categoryGroupIx === 0) ? _c('img', {
      staticClass: "img-responsive center ph5 pt6",
      attrs: {
        "src": _vm.isEnglish ? '/images/menu/en/pitny-rezim.png' : '/images/menu/pitny-rezim.png',
        "alt": "Pitný režim"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "dn-ns"
    }, [(categoryGroupIx === 0) ? _c('img', {
      staticClass: "img-responsive center ph5 pt6",
      attrs: {
        "src": _vm.isEnglish ? '/images/menu/en/pitny-rezim-mobile.png' : '/images/menu/pitny-rezim-mobile.png',
        "alt": "Pitný režim"
      }
    }) : _vm._e()])]
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e63c21a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuOffer.vue
// module id = 106
// module chunks = 1